var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2048px",
    height: "1611px",
    viewBox: "0 0 2048 1611",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.5140479%",
    y1: "100%",
    x2: "73.6222122%",
    y2: "25.1345321%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B5D4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#476B91",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23.8%",
    y: "-15.2%",
    width: "140.2%",
    height: "137.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -50,
    dy: 50,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.6527835%",
    y1: "2.35753272%",
    x2: "92.6563413%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B7ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6661CE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.775585,1.05038168 C482.054286,1.05027158 521.254651,24.7049437 541.37668,72.014398 L1367,1478.10115 L970.210951,1478.10115 C959.335316,1478.10115 841.96194,1490.47359 761.114585,1452.05476 C677.870812,1412.49715 630.993759,1321.64836 612.734883,1288.26918 C513.03998,1106.01622 24.9477255,248.014397 22.8081182,242.464007 C22.778541,242.387281 22.7520345,242.309902 22.7285986,242.231871 L14.3707165,227.251852 C-0.0127797885,188.625777 -3.59906049,150.379021 3.61187437,112.511582 C11.1219994,73.0729785 22.5428145,59.4939098 41.0905901,39.8906947 C77.9369709,0.947613511 133.181755,2.23422951 139.981999,1.05038168 C153.557908,-1.31303514 362.333184,1.05049776 423.775585,1.05038168 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-Copy-5",
    transform: "translate(24, 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1477 L655.525018,237 L984,819.854282 L707.43947,1358.03171 C692.245274,1380.60412 680.433417,1396.04832 672.0039,1404.36429 C659.419179,1416.7795 644.802241,1425.49978 631.759006,1432.77241 C618.460657,1440.18728 601.982933,1452.53827 578.469461,1460.03812 C563.322496,1464.8694 535.190466,1470.52336 494.073371,1477 L0,1477 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    filter: "url(#filter-2)",
    transform: "translate(634, 0)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.cd72e160c6f2e9b3160a6bef2d3b4680.svg";
export { ForwardRef as ReactComponent };